import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import clsx from "clsx";
import React from "react";
import ColorPicker from ".";

interface Props {
  trigger: React.ReactNode;
  selectedColor: string;
  updateCode: (val: string) => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  colorPlateAlign?: "start" | "center" | "end";
  pickerAlign?: "start" | "center" | "end";
  className?:string;
}

const ColorPickerPopover: React.FC<Props> = ({
  trigger,
  selectedColor,
  updateCode,
  setOpen,
  open,
  pickerAlign = "start",
  colorPlateAlign,
  className,
}) => {
  return (
    <div className=" relative ">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>{trigger}</PopoverTrigger>
        <PopoverContent
          align={pickerAlign}
          alignOffset={50}
          className={clsx("bg-white border border-gray-100 cursor-pointer w-64 !px-2 !py-2",className)}
        >
          <ColorPicker
            selectedColor={selectedColor}
            updateCode={updateCode}
            colorPlateAlign={colorPlateAlign}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default ColorPickerPopover;
